export default __webpack_public_path__ + "static/wichrowewzgorze-131773d612401dd42e296a38d60d08db.png";